export default __webpack_public_path__ + "static/media/BumpercoinBrian.967ab566.gif";